var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 49,
    viewBox: "0 0 140 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.797 48.0401H5.40502C2.58194 48.0401 0.269531 45.3819 0.269531 42.1379V6.7245C0.269531 3.48046 2.58194 0.822266 5.40502 0.822266H133.797C136.621 0.822266 138.934 3.48046 138.934 6.7245V42.1379C138.934 45.3819 136.621 48.0401 133.797 48.0401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.799 14.5356C49.799 15.4004 49.5471 16.092 49.0499 16.6088C48.4792 17.2209 47.7352 17.5287 46.8246 17.5287C45.9537 17.5287 45.2097 17.2157 44.5993 16.5983C43.988 15.9722 43.6836 15.2036 43.6836 14.2829C43.6836 13.363 43.988 12.5944 44.5993 11.9727C45.2097 11.351 45.9537 11.0371 46.8246 11.0371C47.2511 11.0378 47.6732 11.127 48.0658 11.2994C48.4589 11.4726 48.7793 11.7052 49.011 11.9928L48.4843 12.5385C48.0793 12.0488 47.5289 11.8066 46.8246 11.8066C46.1888 11.8066 45.6384 12.0339 45.1708 12.493C44.7083 12.9538 44.4758 13.551 44.4758 14.2829C44.4758 15.0157 44.7083 15.6172 45.1708 16.0781C45.6384 16.5327 46.1888 16.7653 46.8246 16.7653C47.4984 16.7653 48.0658 16.5327 48.513 16.0728C48.8089 15.7685 48.9755 15.3497 49.0203 14.8137H46.8246V14.066H49.7533C49.7889 14.2278 49.799 14.3843 49.799 14.5356ZM54.4458 11.9421H51.6946V13.9095H54.1753V14.6571H51.6946V16.6246H54.4458V17.387H50.9159V11.1796H54.4458V11.9421ZM57.7255 17.387H56.9476V11.9421H55.2592V11.1796H59.4147V11.9421H57.7255V17.387ZM62.4221 17.387V11.1796H63.2V17.387H62.4221ZM66.647 17.387H65.8743V11.9421H64.1808V11.1796H68.3406V11.9421H66.647V17.387Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.546503
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M76.2102 16.5878C75.6142 17.2157 74.8761 17.5287 73.9951 17.5287C73.1081 17.5287 72.37 17.2157 71.774 16.5878C71.1787 15.9618 70.8828 15.1932 70.8828 14.2829C70.8828 13.3735 71.1787 12.604 71.774 11.978C72.37 11.351 73.1081 11.0371 73.9951 11.0371C74.871 11.0371 75.6099 11.351 76.2052 11.9832C76.8055 12.6154 77.1014 13.3788 77.1014 14.2829C77.1014 15.1923 76.8055 15.9618 76.2102 16.5878ZM72.3497 16.0676C72.7978 16.5327 73.344 16.7653 73.9951 16.7653C74.6402 16.7653 75.1906 16.5327 75.6345 16.0676C76.0826 15.6032 76.3092 15.0069 76.3092 14.2838C76.3092 13.5598 76.0817 12.9634 75.6345 12.4982C75.1906 12.0339 74.6402 11.8013 73.9942 11.8013C73.344 11.8013 72.7987 12.0339 72.3497 12.4982C71.9016 12.9634 71.675 13.5598 71.675 14.2829C71.675 15.0069 71.9025 15.6032 72.3497 16.0676Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.546503
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1914 17.3871V11.1797H79.1367L82.0756 16.0064H82.1094L82.0756 14.8137V11.1797H82.8534V17.3871H82.0418L78.9642 12.3217H78.9304L78.9642 13.5196V17.3871H78.1914Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.546503
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70.6855 26.4512C68.3173 26.4512 66.382 28.3014 66.382 30.8547C66.382 33.3878 68.3173 35.2582 70.6855 35.2582C73.0588 35.2582 74.9941 33.387 74.9941 30.8547C74.9941 28.3014 73.0588 26.4512 70.6855 26.4512ZM70.6855 33.5234C69.386 33.5234 68.2674 32.4216 68.2674 30.8547C68.2674 29.2668 69.386 28.1851 70.6855 28.1851C71.985 28.1851 73.1086 29.2668 73.1086 30.8547C73.1086 32.4225 71.985 33.5234 70.6855 33.5234ZM61.2972 26.4512C58.9239 26.4512 56.9937 28.3014 56.9937 30.8547C56.9937 33.3878 58.9239 35.2582 61.2972 35.2582C63.6696 35.2582 65.6007 33.387 65.6007 30.8547C65.6007 28.3014 63.6696 26.4512 61.2972 26.4512ZM61.2972 33.5234C59.9968 33.5234 58.8749 32.4216 58.8749 30.8547C58.8749 29.2668 59.9968 28.1851 61.2972 28.1851C62.5967 28.1851 63.7153 29.2668 63.7153 30.8547C63.7153 32.4225 62.5967 33.5234 61.2972 33.5234ZM50.1249 27.8013V29.6725H54.4775C54.3507 30.7183 54.0099 31.4869 53.4883 32.022C52.8525 32.6691 51.8632 33.3878 50.1249 33.3878C47.4464 33.3878 45.3487 31.1686 45.3487 28.4186C45.3487 25.6677 47.4464 23.4485 50.1249 23.4485C51.5732 23.4485 52.6276 24.03 53.4046 24.7828L54.6897 23.4642C53.6016 22.3974 52.1541 21.5781 50.1249 21.5781C46.4521 21.5781 43.3652 24.6473 43.3652 28.4186C43.3652 32.189 46.4513 35.2582 50.1249 35.2582C52.1101 35.2582 53.6016 34.5901 54.7734 33.3371C55.974 32.1042 56.3485 30.3694 56.3485 28.9695C56.3485 28.5349 56.3139 28.1344 56.2505 27.8013H50.1249ZM95.8108 29.2519C95.4566 28.2664 94.3642 26.4512 92.138 26.4512C89.9322 26.4512 88.0958 28.235 88.0958 30.8547C88.0958 33.3214 89.9136 35.2582 92.3494 35.2582C94.3194 35.2582 95.4566 34.0253 95.9241 33.3065L94.4614 32.3062C93.9744 33.0381 93.3099 33.5234 92.3494 33.5234C91.3957 33.5234 90.7109 33.0748 90.2721 32.189L96.0087 29.7521L95.8108 29.2519ZM89.9626 30.7183C89.9136 29.0202 91.2469 28.1502 92.2023 28.1502C92.9506 28.1502 93.5864 28.5349 93.7977 29.0849L89.9626 30.7183ZM85.2997 34.9897H87.1852V22.0486H85.2997V34.9897ZM82.212 27.4323H82.1486C81.7259 26.9164 80.9176 26.4512 79.8937 26.4512C77.7462 26.4512 75.7821 28.3871 75.7821 30.8695C75.7821 33.3371 77.7462 35.2582 79.8937 35.2582C80.9167 35.2582 81.725 34.7878 82.1486 34.2579H82.212V34.8892C82.212 36.5724 81.3361 37.4774 79.9233 37.4774C78.7709 37.4774 78.0564 36.6231 77.7614 35.9052L76.1211 36.6074C76.5946 37.7747 77.8459 39.2114 79.9233 39.2114C82.1334 39.2114 83.9985 37.8762 83.9985 34.626V26.7187H82.212V27.4323ZM80.056 33.5234C78.7557 33.5234 77.6684 32.4068 77.6684 30.8695C77.6684 29.3175 78.7557 28.1851 80.0552 28.1851C81.3361 28.1851 82.3456 29.3175 82.3456 30.8695C82.3456 32.4068 81.3369 33.5234 80.056 33.5234ZM104.639 22.0486H100.129V34.9897H102.01V30.0861H104.639C106.728 30.0861 108.776 28.5349 108.776 26.0664C108.776 23.6006 106.723 22.0486 104.639 22.0486ZM104.688 28.2866H102.01V23.8481H104.688C106.092 23.8481 106.894 25.046 106.894 26.0664C106.894 27.0685 106.092 28.2866 104.688 28.2866ZM116.314 26.4267C114.954 26.4267 113.541 27.0423 112.961 28.4081L114.629 29.126C114.988 28.4081 115.649 28.1746 116.347 28.1746C117.323 28.1746 118.312 28.7771 118.327 29.8395V29.975C117.987 29.7739 117.258 29.474 116.362 29.474C114.565 29.474 112.733 30.4901 112.733 32.3858C112.733 34.1206 114.205 35.2363 115.861 35.2363C117.126 35.2363 117.825 34.6505 118.263 33.9684H118.327V34.9696H120.144V30.0048C120.144 27.7103 118.475 26.4267 116.314 26.4267ZM116.086 33.5181C115.471 33.5181 114.614 33.2051 114.614 32.4225C114.614 31.4204 115.683 31.0366 116.608 31.0366C117.437 31.0366 117.825 31.2237 118.327 31.4711C118.255 32.0345 117.989 32.552 117.577 32.9282C117.165 33.3044 116.635 33.5139 116.086 33.5181ZM126.761 26.71L124.599 32.3202H124.535L122.3 26.71H120.273L123.63 34.5499L121.714 38.9132H123.679L128.853 26.71H126.761ZM109.809 34.9906H111.694V22.0477H109.809V34.9889V34.9906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5036 11.7353C12.2076 12.0536 12.0352 12.5485 12.0352 13.1912V36.0874C12.0352 36.7293 12.2068 37.2242 12.5036 37.5433L12.5763 37.6133L25.0726 24.7884V24.485L12.5763 11.661L12.5036 11.7353Z",
    fill: "url(#paint0_linear_2552_35620)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2379 29.0654L25.0781 24.7878V24.4853L29.243 20.2077L29.336 20.2637L34.2694 23.1457C35.678 23.9633 35.678 25.309 34.2694 26.1327L29.336 29.0086L29.2379 29.0654Z",
    fill: "url(#paint1_linear_2552_35620)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3317 29.0085L25.0729 24.6365L12.5039 37.5427C12.9715 38.0473 13.7341 38.1085 14.6007 37.6039L29.3317 29.0085Z",
    fill: "url(#paint2_linear_2552_35620)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3367 20.2638L14.6066 11.6684C13.74 11.17 12.9773 11.2312 12.5098 11.7349L25.0779 24.6367L29.3367 20.2638Z",
    fill: "url(#paint3_linear_2552_35620)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2552_35620",
    x1: 1204.83,
    y1: -91.1103,
    x2: -802.914,
    y2: -611.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2552_35620",
    x1: 1127.59,
    y1: -413.962,
    x2: -1312.17,
    y2: -413.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2552_35620",
    x1: 1463.69,
    y1: -1531.42,
    x2: -205.93,
    y2: -4268.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2552_35620",
    x1: -303.853,
    y1: 2077.02,
    x2: 441.334,
    y2: 854.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.61c37d1a90bac4c5b122b922a9a5c6ed.svg";
export { ForwardRef as ReactComponent };